import { defineComponent } from "vue";

import PatientPayerInformation from "./PatientPayerInformation/PatientPayerInformation.vue";
import AdmissionInformation from "./AdmissionInformation/AdmissionInformation.vue";

export default defineComponent({
    components: {
        PatientPayerInformation,
        AdmissionInformation
    }
});
